<template>
    <div style="touch-action: none;">
        <div
            class="home-btn"
            style="position:fixed;"
            :style="{ top: top + 'px' }"
            id="right-nav"
            @touchmove="touchmove($event)"
        >
            <router-link to="/" replace class="link">
                <div class="img">
                    <img src="@images/return-home-ico.png" />
                </div>
                <p>主页</p>
            </router-link>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import localStorage from '@utils/store/localStorage';
export default {
    name: 'Home',
    props: {},
    data: function() {
        return {
            top: ''
        };
    },
    computed: mapGetters([]),
    methods: {
        touchmove(e) {
            var that = this;
            if (e.touches[0].clientY < 700 && e.touches[0].clientY > 66) {
                that.top = e.touches[0].clientY;
                localStorage.set('home-top', that.top);
            }
        },
        open: function() {}
    },
    created() {
        try {
            let cache = localStorage.get('home-top');
            this.top = cache || 500;
        } catch (error) {
            this.top = 500;
        }
    }
};
</script>
